<template>
  <q-page padding>
    <q-card
      class="my-card"
      flat
      bordered
    >
      <q-item>
        <q-item-section avatar>
          <q-avatar>
            <q-icon name="email" />
          </q-avatar>
        </q-item-section>

        <q-item-section>
          <q-item-label>Contact</q-item-label>
          <q-item-label caption>
            Send a message to me.
          </q-item-label>
        </q-item-section>
      </q-item>
      <q-separator inset />
      <q-card-section>
        <q-form
          @submit="onSubmit"
          @reset="onReset"
          class="q-gutter-md"
        >
          <q-input
            filled
            clearable
            counter
            minlength="3"
            maxlength="100"
            clear-icon="close"
            v-model="name"
            label="Your name *"
            lazy-rules
            @input=" val => name = $usf.sanitize(val)"
            :rules="[ val => val && val.length > 3 || 'Please name must be longer than 3 characters.']"
          />

          <q-input
            filled
            clearable
            counter
            minlength="8"
            maxlength="100"
            clear-icon="close"
            type="email"
            v-model="email"
            label="Your email *"
            lazy-rules
            :rules="[
          val => val && val.length > 8 || 'Please email must be longer than 8 characters.' ]"
          />

          <q-input
            filled
            clearable
            counter
            minlength="4"
            maxlength="500"
            clear-icon="close"
            label="Your message *"
            v-model="message"
            type="textarea"
            @input=" val => message = $usf.sanitize(val)"
            :rules="[
          val => val && val.length > 3 || 'Please message must be longer than 3 characters.' ]"
          />

          <div>
            <q-btn
              label="Submit"
              type="submit"
              color="primary"
            />
            <q-btn
              label="Reset"
              type="reset"
              color="primary"
              flat
              class="q-ml-sm"
            />
          </div>
        </q-form>
      </q-card-section>
    </q-card>
  </q-page>
</template>

<script>
export default {
  name: 'Contact',
  data () {
    return {
      name: null,
      email: null,
      message: null
    }
  },
  methods: {
    onSubmit () {
      this.$q.notify({
        color: 'positive',
        textColor: 'white',
        icon: 'send',
        message: 'Message sent successfully!'
      })
      this.onReset()
      this.$router.push('/')
    },

    onReset () {
      this.name = null
      this.email = null
      this.message = null
    }
  }

}
</script>

<style lang="stylus" scoped>
.my-card {
  width: 100%;
}
</style>
